import { render } from "./BSkeleton.vue?vue&type=template&id=98dc744c&scoped=true"
import script from "./BSkeleton.vue?vue&type=script&lang=js"
export * from "./BSkeleton.vue?vue&type=script&lang=js"

import "./BSkeleton.vue?vue&type=style&index=0&id=98dc744c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98dc744c"]])

export default __exports__